"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Upgrade/UpgradeModal/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _upgrade = require('shared/enum/upgrade');
var _org = require('shared/selectors/org');

var _hooks = require('web/services/hooks');

var _SMSPlanModal = require('./SMSPlanModal'); var _SMSPlanModal2 = _interopRequireDefault(_SMSPlanModal);
var _CombinedPlanModal = require('./CombinedPlanModal'); var _CombinedPlanModal2 = _interopRequireDefault(_CombinedPlanModal);
var _components = require('./components');










const TeamCommunicationModal = ({
  isOpen, onClose, orgKey, type, hasSms = false, analyticsContext,
}) => {
  const orgName = _hooks.useAppSelector.call(void 0, state => _nullishCoalesce(_optionalChain([_org.selectOrgByKey.call(void 0, orgKey, state), 'optionalAccess', _ => _.Name]), () => ( '')))
  const shouldShowSmsPlanModal =
    type === _upgrade.SubscriptionItemType.SMS && hasSms

  return (
    _react2.default.createElement(_components.PlanModal, { isOpen: isOpen, onClose: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 30}}
      , shouldShowSmsPlanModal
        ? _react2.default.createElement(_SMSPlanModal2.default, { orgKey: orgKey, orgName: orgName, onClose: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 32}} )
        : _react2.default.createElement(_CombinedPlanModal2.default, {
            orgKey: orgKey,
            orgName: orgName,
            onClose: onClose,
            isSmsPreselected: type === _upgrade.SubscriptionItemType.SMS,
            analyticsContext: analyticsContext, __self: this, __source: {fileName: _jsxFileName, lineNumber: 33}}
          )
      
    )
  )
}

exports. default = _react.memo.call(void 0, TeamCommunicationModal)
